import { render } from "./LoginForm.vue?vue&type=template&id=89d99208&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=89d99208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89d99208"]])

export default __exports__